import React, { useEffect } from 'react';
import './style.scss';
import Link from '../../controls/link';
import clsx from 'clsx';
import useCream from '../../../contexts/cream';
import CreamCan from '../../../assets/images/common/creamCan';

interface Props {
  inverted: boolean;
  onClick?: () => void;
  className?: string;
}

const BalanceBlock = ({ inverted, onClick, className }: Props) => {
  const { balance, getBalance, balanceLoading } = useCream();

  useEffect(() => {
    getBalance();
  }, []);

  return (
    <Link
      to='/creamshop'
      color={inverted ? 'default' : 'white'}
      className={clsx('balance-block', inverted && 'inverted', className)}
      onClick={onClick}
      disableHover
    >
      <div className='balance-block-button'>
        <CreamCan className='balance-block-button-image' />
        <h2
          className={clsx(
            'balance-block-amount',
            balanceLoading && 'text-loading'
          )}
        >
          {balance >= 0 ? balance : '...'}
        </h2>
      </div>
    </Link>
  );
};

export default BalanceBlock;
